<template>
  <div>
    <slot v-if="isLoading" />

    <iframe
      ref="content"
      v-bind="attrs"
      :class="{ 'opacity-0': !embedLoaded }"
      :width="width"
      @load="onLoadIFrame"
    />
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    maxIteration: {
      type: Number,
      default: 10
    }
  },

  data () {
    return {
      resizeCount: this.maxIteration,
      interval: null,
      isLoading: true,
      embedLoaded: false
    }
  },

  computed: {
    attrs () {
      return {
        ...this.$attrs
      }
    }
  },

  methods: {
    onLoadIFrame (event) {
      const iframe = event.target
      const doc = iframe.contentDocument

      const tagStyle = document.createElement('style')
      tagStyle.innerHTML = `
        body { margin: 0; }
        body > :not(script):not(style) { margin: 0 auto !important; display: inherit !important; }
      `
      doc.head.appendChild(tagStyle)
      this.listenToResize(iframe, doc)
    },

    listenToResize (iframe, doc) {
      this.interval = setInterval(() => {
        this.resizeCount--

        if (
          this.resizeCount === 0 ||
          iframe.offsetHeight !== doc.body.offsetHeight
        ) {
          iframe.style.height = doc.body.offsetHeight + 'px'
        }

        if (this.resizeCount === 0) {
          this.showEmbed()
        }
      }, 300)
    },

    showEmbed () {
      this.isLoading = false
      this.embedLoaded = true
      this.$emit('loaded')

      clearInterval(this.interval)
    }
  }
}
</script>
